export const ACR_GROUPED_TO_CQS_MAP = {
  D: 0,
  'CCC/C': 15,
  B: 30,
  BB: 45,
  BBB: 60,
  A: 75,
  'AAA/AA': 90,
};

export const ACR_TO_CQS_MAP = {
  D: 0,
  'C/CC': 5,
  CCC3: 10,
  CCC2: 15,
  CCC1: 20,
  B3: 25,
  B2: 30,
  B1: 35,
  BB3: 40,
  BB2: 45,
  BB1: 50,
  BBB3: 55,
  BBB2: 60,
  BBB1: 65,
  A3: 70,
  A2: 75,
  A1: 80,
  AA3: 85,
  AA2: 90,
  AA1: 95,
  AAA: 100,
};
